import React from 'react'
import Forms from '../components/Forms'
import { Link } from "react-router-dom";

export default function ContactUs() {
  const bannerstyle = {
    margin: '0px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center', 
    paddingBottom: '3%'
  }
  
  return (
    <div>
      
        <section className="banner" style={bannerstyle}>
           <div className="container-fluid">
               <div className="row">
                   <div className="col-md-12 p-0">
                       <div className="sub-banner">
                          <img src="/assets/img/banner-contact.jpg" className="d-block w-100" alt="..." />
                          
  
                       </div>
                   </div>
               </div>
           </div>
           <div className="container aboutHead">
                <div className="row">
                    <div className="col-md-12">
                         <h1>Contact Us</h1>
                    </div>
                </div>
           </div>
       </section>

<section className="contact"> 
      <div className="container">
        <div className='row'>
          <div className='col-md-7 my-4'>
            <ul>
                <li>
                    <span><img src='/assets/img/mail-ic.png' alt='Mail'/></span>
                    <span>
                        <h2>Drop a Mail</h2>
                        <Link mailto='info@unlockdestinations.in'>info@unlockdestinations.in</Link>
                    </span>
                </li>
                <li>
                    <span><img src='/assets/img/phone-ic.png' alt='Phone'/></span>
                    <span>
                        <h2>Call Us</h2>
                        <Link tel='+918766234500'>+91 8766234500</Link>
                    </span>
                </li>
                <li>
                    <span><img src='/assets/img/loc-ic.png' alt='Location'/></span>
                    <span>
                        <h2>Connect with us</h2>
                        <p>B-45, Block L, Lajpat Nagar II, Lajpat Nagar, New Delhi, Delhi 110024</p>
                    </span>
                </li>
            </ul>
          </div>
          <div className='col-md-5 my-4'>
            <div className="queryForm contactFrm">
                <h2>Any Query? <strong>Call Now</strong></h2>
                <Forms submitBtnName="Submit" formsource="Banner"/>
            </div>
          </div>
        </div> 
      </div>
</section>

<section className="contactSocial">
   <div className="container">
      <div className="row">
        <div className="col-md-12">
          <div className="social">
                            <ul>
                              <li><Link target='_blank' to="https://www.facebook.com/unlock.destinations/"><img src="/assets/img/facebook.png" alt="Facebook" /><span>Facebook</span></Link></li>
                              <li><Link target='_blank' to="https://www.instagram.com/unlock_destinations/"><img src="/assets/img/instagram.png" alt="Instagram" /><span>Instagram</span></Link></li>
                              <li><Link target='_blank' to="https://www.google.com/search?q=unlock+destinations+reviews&sca_esv=f0158aba78c19323&sxsrf=AE3TifPw0RXASIiECFGdEeXNS5MwXU-Mlg%3A1765546875802&ei=exs8afHLMNuUseMP9IfliAw&oq=unlock+destinations+&gs_lp=Egxnd3Mtd2l6LXNlcnAiFHVubG9jayBkZXN0aW5hdGlvbnMgKgIIATIGEAAYFhgeMgYQABgWGB4yBhAAGBYYHjICECYyCxAAGIAEGIYDGIoFMgsQABiABBiGAxiKBTIIEAAYgAQYogQyCBAAGIAEGKIESLYSUKwEWKwEcAB4ApABAJgBxAGgAcQBqgEDMC4xuAEByAEA-AEBmAICoALWAcICBBAAGEeYAwDiAwUSATEgQIgGAZAGApIHBTEuMC4xoAe8BbIHAzItMbgHzgHCBwMyLTLIBwuACAA&sclient=gws-wiz-serp#lrd=0x390ce33bbb6ba2ff:0x3f0a39a03443fc23,1,,,,"><img className="google" src="/assets/img/google.png" alt="Google" /></Link></li>
                            </ul>
                        </div>
        </div>
      </div>
   </div>
  </section>            

    </div>
  )
}
